import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

function useNonInitialEffect(callback: EffectCallback, dependencies: DependencyList): void {
  const initialRender = useRef(true);

  // This hook intentionally mirrors useEffect dependencies from the caller and skips the first run.
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    return callback();
  }, dependencies);
  /* eslint-enable react-hooks/exhaustive-deps */
}

export default useNonInitialEffect;
